module.exports = __webpack_public_path__ + "img/wing_mobile.a5bf2925.png";